export default __webpack_public_path__ + "static/media/gbc_logo.8abd0831.png";